import React from 'react';
import { SitecoreImageField } from 'components/sitecore-fields';
import MastercardPromoPanelTiles from './MastercardPromoPanelTiles';
import userService from '../../../../general/js/user/user-service';
import { handleMastercardRegistrationEnforce } from '../helpers/toch-helpers';
import { addQueryParams, redirectTo } from '../../../../general/js/utils';
import { QueryConstants } from '../../../../general/js/utils/query-constants';

class MastercardPromoPanel extends React.Component {
    constructor(props) {
        super(props);

        this.onClick = this.onClick.bind(this);
    }

    componentDidMount() {
    }

    onClick = (tile) => {
        const {
            mastercardRegistrationPage
        } = this.props.options;

        if (handleMastercardRegistrationEnforce(this.props.options)) {
            redirectTo(addQueryParams(mastercardRegistrationPage.url, [
                {
                    key: QueryConstants.REDIRECT_URL,
                    value: tile.link.url
                }
            ]));
            return;
        }

        if (tile.redirectsToRestrictedContent) {
            userService.setDataInLocalStorage(QueryConstants.REDIRECT_URL, tile.link.url);
            redirectTo(tile.link.url);
        } else redirectTo(tile.link.url);
    }

    render() {
        const {
            mastercardLogo,
            mastercardText,
            theOneClubLabel,
            mastercardBranding,
            title,
            subtitle,
            tiles,
            mastercardPromoPanelId,
            backgroundImage
        } = this.props.options;

        return (
            <div id={mastercardPromoPanelId}>
                {
                    mastercardBranding !== null &&
                <div className="mastercard-promo-panel__bg">
                    <SitecoreImageField img={mastercardBranding.background} className="mastercard-promo-panel__bg--desktop"></SitecoreImageField>
                    <SitecoreImageField img={mastercardBranding.mobileBackground} className="mastercard-promo-panel__bg--mobile"></SitecoreImageField>
                </div>
                }
                {
                    mastercardBranding === null &&
                    <div className="mastercard-promo-panel__bg">
                        <SitecoreImageField img={backgroundImage} className="mastercard-promo-panel__bg--desktop"></SitecoreImageField>
                    </div>
                }
                <div className="mastercard-promo-panel__container container">
                    <div className="mastercard-promo-panel__header">
                        {
                            mastercardLogo !== null &&
                            <div className="mastercard-branding">
                                <div className="mastercard-branding--title">{mastercardText}</div>
                                <SitecoreImageField img={mastercardLogo} className="mastercard-branding--logo"></SitecoreImageField>
                            </div>
                        }
                        <div className="mastercard-promo-panel__header--content">
                            <div className="mastercard-promo-panel__tag">
                                {theOneClubLabel}
                            </div>
                            <h3 className="mastercard-promo-panel__title">
                                {title}
                            </h3>
                            <div className="mastercard-promo-panel__subtitle">
                                {subtitle}
                            </div>
                        </div>
                    </div>
                    {
                        tiles !== null &&
                        <MastercardPromoPanelTiles
                            tiles={tiles}
                            onClick={this.onClick} />
                    }
                </div>
            </div>
        );
    }
}


export default (MastercardPromoPanel);
